import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ReactComponent as Icon } from 'src/assets/images/fortune/ic-nookpoint.svg';
import { FadeInImage } from 'src/components/shared/FadeInImage';
import { formatNumber } from 'src/lib/format-number';
import { catalogIconUrl } from 'src/models/catalog/CatalogItem';
import { FortuneItem } from 'src/models/fortune/FortuneItem';

interface FortuneExchangeableItemListItemProps {
  item: FortuneItem;
}

export const FortuneExchangeableItemListItem: React.FC<FortuneExchangeableItemListItemProps> = ({
  item
}) => {
  const history = useHistory();
  const { i18n } = useTranslation();

  const handleClick = useCallback(() => {
    history.push(`/players/fortune/exchange/detail/${item.unique_id}`);
  }, [history, item.unique_id]);

  return (
    <li
      className={css`
        width: 50%;
        padding: 8px;
      `}
    >
      <button
        onClick={handleClick}
        className={css`
          width: 100%;
          padding: 16px 8px;
          border-radius: 16px;
          background-color: #e7f7c9;
          transition: transform 0.1s ease;

          &:active {
            transform: scale(0.98);
          }

          .text-area {
            display: flex;
            flex-direction: column;
            overflow: hidden;
          }
          .text {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .label {
            color: #4d3906;
            font-size: 12px;
            margin: 8px 0;
          }
          .required-point-area {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .value {
            color: #33a142;
            font-size: 16px;
            margin-left: 2px;
          }
          .img {
            height: 128px;
            width: 128px;
            margin: 0 auto;
          }
          @media screen and (max-width: 342px) {
            .img {
              height: 96px;
              width: 96px;
            }
          }
        `}
      >
        <div className="img">
          <FadeInImage src={catalogIconUrl(item.icon)} />
        </div>
        <div className="text-area">
          <span className="text label">{item.label}</span>
          <div className="required-point-area">
            <Icon width={24} height={24} />
            <span className="text value">{formatNumber(item.point, i18n.language)}</span>
          </div>
        </div>
      </button>
    </li>
  );
};
